import React from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

function RadioSelect({ value, valueArray, onClick }) {
  const displayedValues = valueArray.sort();

  const radios = (
    <Grid item xs={12}>
      <FormControl>
        <RadioGroup row value={value} onChange={onClick}>
          {displayedValues.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={option}
              sx={{ paddingRight: 5 }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );

  return (
    <Grid item xs={12}>
      {radios}
    </Grid>
  );
}

export default RadioSelect;
